import { Directive, ElementRef, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[appResizable]'
})
export class ResizableDirective implements OnInit {
  
  @Input('appResizable') directions: string[];

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    const element: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
    let dir = this.directions || ['right'];
    
    for (let i = 0; i < dir.length; i++) {
      const direction = dir[i];
      let handle = document.createElement('div');
      handle.setAttribute('class', 'resize-handle-'+direction);
      handle.innerHTML = '<span></span>';
      element.appendChild(handle);
    }
    // dir.forEach((direction) => {
    //   let handle = document.createElement('div');
    //   handle.setAttribute('class', 'resize-handle-'+direction);
    //   handle.innerHTML = '<span></span>';
    //   element.appendChild(handle);
    // });
  }
}